import React from 'react';
import { useLanguage } from './LanguageContext';
import { visibleNavItems } from '../navItems';
import { LogoutIcon, CloseIcon } from './NavIcons';
import SidebarBrand from './SidebarBrand';
import SidebarUser from './SidebarUser';

/**
 * The desktop sidebar's content, as a phone drawer. Same list, same order —
 * it renders from navItems.js like the sidebar does, so the two cannot drift.
 */
const NavDrawer = ({ open, admin, currentPage, onNavigate, onLogout, onClose }) => {
  const { print_lang } = useLanguage();

  if (!open) return null;

  const choose = (id) => {
    onNavigate(id);
    onClose();
  };

  return (
    <>
      <div className="nav-drawer-scrim" onClick={onClose} />
      <aside className="nav-drawer" role="dialog" aria-label={print_lang('nav.menu', 'Menu')}>
        <div className="nav-drawer-header">
          <div>
            <SidebarBrand />
          </div>
          <button
            type="button"
            className="nav-drawer-close"
            onClick={onClose}
            aria-label={print_lang('common.close', 'Close')}
          >
            <CloseIcon className="sidebar-nav-icon" />
          </button>
        </div>

        <nav>
          <ul className="nav-drawer-list">
            {visibleNavItems(admin).map(({ id, labelKey, labelFallback, Icon }) => (
              <li key={id}>
                <button
                  type="button"
                  className={`nav-drawer-item ${currentPage === id ? 'active' : ''}`}
                  onClick={() => choose(id)}
                >
                  <Icon className="sidebar-nav-icon" />
                  {print_lang(labelKey, labelFallback)}
                </button>
              </li>
            ))}
            <li>
              <button
                type="button"
                className="nav-drawer-item"
                onClick={() => { onLogout(); onClose(); }}
              >
                <LogoutIcon className="sidebar-nav-icon" />
                {print_lang('nav.logout', 'Logout')}
              </button>
            </li>
          </ul>
        </nav>

        <div className="nav-drawer-footer">
          <SidebarUser admin={admin} userClassName="nav-drawer-user" />
        </div>
      </aside>
    </>
  );
};

export default NavDrawer;
